import { Map } from "immutable";

import SyncCustomFieldOptions from "../../../constants/SyncCustomFieldOptions";
import syncLocalFields from "../../../constants/syncLocalFields";
import { SyncFieldSettingsRecord } from "../../../types/immutableRecords/model/sync/SyncFieldSettingsRecord";

export const defaultScrivenerFields = Map({
  [syncLocalFields.label]: SyncFieldSettingsRecord({
    id: syncLocalFields.label,
    customFieldId: SyncCustomFieldOptions.TITLE,
    customFieldName: null
  }),
  [syncLocalFields.summary]: SyncFieldSettingsRecord({
    id: syncLocalFields.summary,
    customFieldId: SyncCustomFieldOptions.SYNOPSIS,
    customFieldName: null
  })
});

export const defaultUlyssesFields = Map({
  [syncLocalFields.label]: SyncFieldSettingsRecord({
    id: syncLocalFields.label,
    customFieldId: SyncCustomFieldOptions.TITLE,
    customFieldName: null
  })
});
